import { type DetailsPageProps } from 'app/main/components/page-layouts';

import LeaveDetailsTab from './tabs/LeaveDetailsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <LeaveDetailsTab {...props} />
	}
];

export default tabs;
